import { colors as uiColors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

import { colors, fonts } from '../styles';

export const mainContainer = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px;
  background-color: ${uiColors.danger[11]};
  width: 100%;
  position: relative;
`;

export const messageContainer = css`
  display: flex;
  flex-direction: column;
`;

export const titleRow = css`
  display: flex;
  flex-flow: row;
  border-radius: 5px;
`;

export const warnIcon = css`
  flex-shrink: 0;
  align-self: center;
  margin-right: 10px;
  color: ${colors.white};
`;

export const title = css`
  color: ${colors.white};
`;

export const descriptionRow = css`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
`;

export const description = css`
  margin-left: 25px;
  color: ${colors.white};
`;

export const linkFAQ = css`
  color: ${colors.white};
  font-weight: ${fonts.weight.bold};
  font-size: ${fonts.size.smallest};
  cursor: pointer;
  text-decoration: underline;
  width: fit-content;
  height: fit-content;
  display: inline;
  :hover {
    color: ${colors.white};
  }
`;

export const actionsContainer = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: 20px;
`;

export const button = css`
  background-color: white;
  color: ${colors.primary.default};

  &:hover {
    background-color: ${colors.gray.light};
  }
`;
